import PhotosSearchBrowseModalContainer from '../src/PhotosSearchBrowse/PhotosSearchBrowseModalContainer.tsx';
export default PhotosSearchBrowseModalContainer;
